import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tasks: [],
  currentTask: null,
}

const taskSlice = createSlice({
  name: 'taskList',
  initialState,
  reducers: {
    setTasks: (state, action) => {
      state.tasks = action.payload.tasks;
    },
    createTask: (state, action) => {
      const newTask = action.payload;
      const existingTask = state.tasks.find(task => task.id === newTask.id);
      if (!existingTask) {
        state.tasks.push(newTask);
      }
    },
    addTasks: (state, action) => {
      const newTasks = action.payload.tasks?.filter(newTask => 
        !state.tasks?.some(existingTask => existingTask.id === newTask.id)
      );
      state.tasks?.push(...newTasks);
    },
    saveTask: (state, action) => {
      const taskIndex = state.tasks.findIndex(t => t.id === action.payload.task?.id)
      if (taskIndex !== -1) {
        state.tasks[taskIndex] = {
          ...state.tasks[taskIndex],
          ...action.payload.task
        }
      }
      if (state.currentTask?.id === action.payload.task?.id) {
        state.currentTask = state.tasks[taskIndex]
      }
    },
    updateTask: (state, action) => {
      const taskIndex = state.tasks.findIndex(t => t.id === action.payload.id)
      if (taskIndex !== -1) {
        state.tasks[taskIndex] = { ...action.payload }; // Ensures new reference
      }
      state.currentTask = { ...action.payload }; // Ensures new reference
    },
    deleteTask: (state, action) => {
      const taskIndex = state.tasks.findIndex(t => t.id === action.payload)
      if (taskIndex !== -1) {
        state.tasks.splice(taskIndex, 1)
      }
    },
    setCurrentTask: (state, action) => {
      state.currentTask = state.tasks.find(t => t.id === action.payload) || null
    },
    syncTasksFromDB: (state, action) => {
      const dbTasks = action.payload.tasks || [];
      dbTasks.forEach(dbTask => {
        const existingIndex = state.tasks.findIndex(t => t.id === dbTask.id);
        if (existingIndex !== -1) {
          // Update existing task
          state.tasks[existingIndex] = {
            ...state.tasks[existingIndex],
            ...dbTask
          };
        } else {
          // Add new task
          state.tasks.push(dbTask);
        }
      });
    },
  },
})

export const { 
  setTasks,
  createTask,
  addTasks,
  saveTask,
  updateTask,
  deleteTask,
  setCurrentTask,
  syncTasksFromDB,
} = taskSlice.actions

export default taskSlice.reducer;
